WiseMetering.Views.UtilitiesCosts = Backbone.Marionette.Layout.extend({
    template: 'templates/utilities/costs',
    regions: {
        container: '#utility-costs-container'
    },

    onShow: function() {
        const utilities = WiseMetering.utilities.where({ site_id: this.model.site().id, utility_kind_id: WiseMetering.utilityKinds.findWhere({ slug: 'electricity' }).id });

        // Utilities without contracts have no dates and no costs
        const withContracts = utilities.filter(utility => utility.start());
        if (withContracts.length === 0) {
            WiseMetering.layout.showTipper('info', i18next.t('ui.no_data_available'));
            return;
        }

        const minDate = withContracts.map(utility => utility.start()).reduce((min, c) => c < min ? c : min);
        const maxDate = withContracts.map(utility => utility.finish()).reduce((max, c) => c > max ? c : max);

        const costView = new WiseMetering.Views.Costs({
            maxDate,
            minDate,
            model: this.model.site(),
            withUtilityKind: true
        });

        this.container.show(costView);
    }
});
